import {Action} from 'redux'

export const LOADING = 'LOADING'

export class LoadingAction implements Action {
  public type: typeof LOADING
  public status: boolean

  constructor() {
    this.status = false
    this.type = LOADING
  }
}

type LoadingInvoke = (status: boolean) => LoadingAction

export const loading: LoadingInvoke = (status: boolean) => ({
  status,
  type: LOADING,
})
